import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-class-filter")
class ClassFilter extends HTMLElement {
  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.filter}">
        <button class="${style.filter__class}">Todas</button>  
        <button class="${style.filter__class}">Turma 1</button>  
        <button class="${style.filter__class}">Turma 2</button>  
        <button class="${style.filter__class}">Turma 3</button>  
        <button class="${style.filter__class}">Turma 4</button>  
      </div>
    `;
  }
}

export default ClassFilter;
